export function getHeaders() {
    let headers = {};
    //if (window.__pt.settings.site.hasActive) {
        headers = {
            "x-Token": window.__pt.settings.site.token
        };
    //}
    return headers;
}
